import React from 'react';

import { Box, Toolbar, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import IconJadesoftNew from '../../components/Icons/IconJadesoftNew';
import useToggle from '../../hooks/use-toggle';
import LanguageSettings from './LanguageSettings';
import CustomAppBar from './styles';

import { languageItems } from '../../config';
import { TOGGLE_LIST_MENU } from '../../constants/global';

import NavigationMenu from '../NavigationMenu';

const TopNavigation = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const pages = [
    {
      label: t('home'),
      path: '/',
      subPath: [],
      hasMenu: false,
    },
    {
      label: t('solution'),
      path: '/solutions',
      subPath: ['/white-label', '/self-service', '/turnkey'],
      hasMenu: true,
    },
    {
      label: t('game-api'),
      path: '/game-apis',
      subPath: [],
      hasMenu: false,
    },
    // {
    //   label: 'Services',
    //   path: '/home',
    //   hasMenu: false,
    // },
    {
      label: t('contact'),
      path: '/contact',
      subPath: [],
      hasMenu: false,
    },
    {
      label: t('about-us'),
      path: '/about-us',
      subPath: [],
      hasMenu: false,
    },
    // {
    //   label: 'ENG',
    //   path: '/home',
    // },
  ];

  const { toggle, toggleClickOpen, toggleClickClose } = useToggle({
    toggleList: TOGGLE_LIST_MENU,
  });

  const onChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    toggleClickClose('navLanguageOptions');
  };

  return (
    <CustomAppBar color="primary" position="fixed">
      <Toolbar
        className="toolBar"
        disableGutters
        sx={{
          mr: 2,
          alignItems: 'center',
          display: { xs: 'flex' },
          // justifyContent: 'space-between',
          minHeight: '83px !important',
        }}
      >
        <Box
          display="flex"
          sx={{
            width: '261px',
            [theme.breakpoints.down('md')]: {
              width: '200px !important',
            },
          }}
          onClick={() => navigate('/')}
        >
          <IconJadesoftNew class="jadeSoftIcon" />
        </Box>

        <Box sx={{ flexGrow: 0, marginLeft: 10 }}>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' }, alignItems: 'center' }}>
            <NavigationMenu pages={pages} />
            <LanguageSettings
              onChangeLanguage={onChangeLanguage}
              options={languageItems}
              toggle={toggle.navLanguageOptions}
              toggleClose={() => toggleClickClose('navLanguageOptions')}
              toggleOpen={(e) => toggleClickOpen(e, 'navLanguageOptions')}
            />
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex', lg: 'none', xl: 'none' } }}>
            <NavigationMenu pages={pages} />
            {/* <LanguageSettings
              onChangeLanguage={onChangeLanguage}
              options={languageItems}
              toggle={toggle.navLanguageOptions}
              toggleClose={() => toggleClickClose('navLanguageOptions')}
              toggleOpen={(e) => toggleClickOpen(e, 'navLanguageOptions')}
            /> */}
          </Box>
        </Box>
      </Toolbar>
    </CustomAppBar>
  );
};

export default TopNavigation;
